// packages/whiteboard/src/features/rectangle/rectangle-options.config.ts

import {
  FILL_ACTIONS,
  BORDER_ACTIONS,
  BORDER_WIDTH_ACTIONS,
  BORDER_RADIUS_ACTIONS,
  BORDER_STYLE_ACTIONS,
  BOX_SHADOW_ACTIONS,
  BACKGROUND_OPACITY_ACTIONS,
  Z_ORDER_ACTIONS,
  ALIGN_ACTIONS,
  BOARD_COMMAND_ACTIONS,
  type OptionsCircleDef,
} from '../../optionsbar/optionsbar-actions.js';
import { composeOptionsCircle } from '../../optionsbar/parts/compose-options-circle.js';

// Optionskreis aus Einzelteilen zusammengesetzt (Rechteck = 1+2+3+5):
// Standard-Knöpfe + Rahmen/Linien-Optionen + Füllfarben + Eckenrundung.
const rectangleSvg = composeOptionsCircle([1, 2, 3, 5]);

/**
 * Rectangle-specific optionsbar definition (PRD-F1 §T14). The slice owns the
 * SVG/action mapping for its own optionsbar circle. Composed ENTIRELY from
 * shared action maps — no rectangle-specific action code. The rectangle
 * supports fill / strokeColor / strokeWidth / cornerRadius plus (added later)
 * strokeStyle / boxShadow / backgroundOpacity; the intent → property mapping
 * lives in optionsbar-config's `resolveProperty`. Z-order and board commands
 * are object-type agnostic and handled directly by the optionsbar element.
 */
export const RECTANGLE_OPTIONS: OptionsCircleDef = {
  svg: rectangleSvg,
  actions: {
    ...FILL_ACTIONS,
    ...BORDER_ACTIONS,
    ...BORDER_WIDTH_ACTIONS,
    ...BORDER_RADIUS_ACTIONS,
    ...BORDER_STYLE_ACTIONS,
    ...BOX_SHADOW_ACTIONS,
    ...BACKGROUND_OPACITY_ACTIONS,
    ...Z_ORDER_ACTIONS,
    ...ALIGN_ACTIONS,
    ...BOARD_COMMAND_ACTIONS,
  },
};
